export const UPDATE_SOCIAL_NETWORKS = 'UPDATE_SOCIAL_NETWORKS'
